export const getNavLinkClassName = ({ isActive }: { isActive: boolean }) =>
  isActive ? "active" : "";
